import { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { SocialLinkItem } from "./SocialLinkItem";
import plusIcon from "components/icons/plusIcon.svg";
import { IInput } from "./VerifyStep";
import "./styles/SocialLinksForm.scss";

interface updateInputData {
  value: string;
  name: string | null;
  validMessage: string | null;
  isRequired: boolean;
}

interface ISocialLinksFormProps {
  handleUpdateInputs: (inputs: IInput[]) => void;
  inputFormList: IInput[];
}

export const SocialLinksForm = ({ handleUpdateInputs, inputFormList }: ISocialLinksFormProps) => {
  const [inputList, setInputList] = useState<IInput[]>(inputFormList);
  const [disableBtn, setDisableBtn] = useState(false);

  useEffect(() => {
    const isInputValid = inputList.filter(({ name }) => name).length;
    const isDisableBtn = inputList.length && !(isInputValid === inputList.length);

    if (isDisableBtn) {
      setDisableBtn(true);
    } else {
      setDisableBtn(false);
    }

    handleUpdateInputs(inputList);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputList]);

  const handleAddInput = () => {
    const newInput = { id: uuidv4(), name: null, value: "", validMessage: null, isRequired: false };
    const newInputList = [...inputList, newInput];

    setInputList(newInputList);
  };

  const removeInput = (id: string) => {
    const newInputList = inputList.filter(input => input.id !== id);

    setInputList(newInputList);
  };

  const updateInput = (id: string, inputToUpdateValues: updateInputData) => {
    const updatedInput = inputList.map((input) => input.id === id ? { ...input, ...inputToUpdateValues } : { ...input });

    setInputList(updatedInput);
  };

  const renderInputsList = () => {
    if (!inputList.length) {
      return null;
    }

    return (
      <div className="SocialLinksForm-List">
        {inputList.map((input) => (
          <SocialLinkItem
            updateInput={updateInput}
            removeInput={removeInput}
            key={input.id}
            {...input}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="SocialLinksForm">
      {renderInputsList()}
      <button
        onClick={handleAddInput}
        className="SocialLinksForm-Btn"
        disabled={disableBtn}
      >
        {inputList.length ? "Add more" : "Add link"}
        <span><img src={plusIcon} alt="Add link" /></span>
      </button>
    </div>
  );
};
